import { App } from 'vue';

import CartSummary from '@/components/Cart/CartSummary/CartSummary.vue';
import { initHobbiiStarter } from '@/shared/instances/hobbii-starter';

import type { InitializationState } from './index';
import { cartSummaryMountSelector } from './index';
import { initializeComponent } from './shared';

export const initCartSummary = async (
  waitForCartUpdate = false,
  mountedApps: Map<string, App>,
  initializationState: InitializationState
): Promise<void> => {
  const containerId = 'cart-summary';

  await initHobbiiStarter();

  await initializeComponent({
    containerId,
    mountSelector: cartSummaryMountSelector,
    component: CartSummary,
    state: initializationState.cartSummary,
    mountedApps,
    waitForCartUpdate,
    extractProps: (container) => ({
      shippingThreshold: Number(container.dataset.shippingThreshold || 0),
      lowestShippingPrice: Number(container.dataset.lowestShippingPrice || 0),
      showSalesTaxMessage: container.dataset.showSalesTaxMessage === 'true',
      display: 'main' as const
    })
  });
};
